/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "AmethystAI",
  "description": "Experimental AI coding assistant shell. When enabled, a sidebar appears in the editor; when disabled, it leaves no UI behind.",
  "info": [
    {
      "type": "warning",
      "text": "Experimental: this UI shell does not send API requests yet. API keys and agent permissions still need a safe design before live AI control is enabled.",
      "id": "experimental"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "sidebar.css"
    }
  ],
  "tags": [
    "beta",
    "danger"
  ],
  "enabledByDefault": false
};
export default manifest;
